import { Select } from "@/common/components/selectInput";
import { LargeCard } from "../../stats/subs/LargeCard";
import {
  accountantFinancialsCards,
  accountantFinancialsTableHeaders,
  accountantFinancialsTableKeys,
  getAccountantFinancialsTableData,
} from "../data";
import { AccountantFinancialsWrapper } from "../style";
import { Button } from "@/common/components/button";
import Table from "@/common/components/Table";

const AccountantFinancials = () => {
  return (
    <AccountantFinancialsWrapper>
      <div className="card-wrapper">
        {accountantFinancialsCards?.map((card: any) => (
          <LargeCard
            color={card.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      {/* export data */}
      <div className="export-wrapper">
        <div className="select-wrapper">
          <Select
            name="Sort"
            formValues={[]}
            shortWidth
            fullWidth={false}
            placeholder="Sort By"
            prompt=""
            indexLevel={0}
            setFormValues={() => {}}
            options={[
              {
                title: "2025",
                value: "2025",
              },
              {
                title: "2024",
                value: "2024",
              },
            ]}
          />
        </div>
        <Button>Export</Button>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={accountantFinancialsTableHeaders}
          tableKeys={accountantFinancialsTableKeys}
          tableData={getAccountantFinancialsTableData()}
          tableTitle="Financial Report"
          rowLineColor="light"
        />
      </div>
    </AccountantFinancialsWrapper>
  );
};

export default AccountantFinancials;
